export default __webpack_public_path__ + "static/media/excel2018.b18bf667.png";